import { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab/";
import { Box, Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(1),
  },
  button: {
    width: "100%",
    minHeight: "2rem",
    height: "auto",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.white,
    border: "1px solid " + theme.palette.border.main,
    textTransform: "inherit",
    fontSize: "0.9rem",
    padding: theme.spacing(0.4),
    fontWeight: theme.typography.fontWeightMedium,
    "&:not(:last-child)": {
      borderRight: "2px solid " + theme.palette.border.main,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.button.main + "!important",
      color: theme.palette.text.secondary,
      fontWeight: "600",
    },
  },
}));

const ButtonField = ({ name, label, choices = [], onChange }) => {
  const classes = useStyles();
  const { watch, register, unregister, setValue } = useFormContext();
  const currentValue = watch(name);

  useEffect(() => {
    register(name);

    return () => {
      unregister(name, { keepValue: true });
    };
  }, [name, register, unregister]);

  const handleChange = useCallback(
    (event, newValue) => {
      if (newValue !== null) {
        setValue(name, newValue);
        onChange(name, newValue);
      }
    },
    [name, setValue, onChange]
  );

  return (
    <>
      <Typography variant="body1">{label}</Typography>
      <Box align="center">
        <ToggleButtonGroup
          exclusive
          value={currentValue}
          onChange={handleChange}
          size="small"
          orientation="horizontal"
          aria-label={label}
          className={classes.root}
        >
          {choices.map(({ key, label }) => (
            <ToggleButton
              key={key}
              value={key}
              aria-label={label}
              selected={currentValue === key}
              className={classes.button}
            >
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </>
  );
};

ButtonField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  choices: PropTypes.array.isRequired,
  validations: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default ButtonField;
